<template>
  <section class="hero-section">
    <div class="container">
      <div class="hero-section-top">
        <div class="hero-section-left">
          <div class="hero-heading">
            <div class="heading">
              <p class="badge">{{ heroBadge }}</p>
              <h1>{{ page.title }}. Build your future now, not later</h1>
            </div>
            <NuxtPicture
              src="/images/role-page/hero-section/hero-dev.webp"
              alt="hero"
            />
          </div>
          <div class="data-information">
            <div>
              <GradientCheckIcon />
              300+ new jobs every month
            </div>
            <div>
              <GradientCheckIcon />
              Career coaching
            </div>
            <div>
              <GradientCheckIcon />
              Top 2% talent network
            </div>
          </div>

          <div class="buttons">
            <ApplyButton
              page-name="homepage"
              cta-section="hero"
              class="proxify-btn proxify-btn-white"
            />
            <Glassdoor score="4.2" />
          </div>
        </div>
        <div class="hero-section-right">
          <NuxtPicture
            src="/images/role-page/hero-section/hero-dev.webp"
            alt="hero"
          />
        </div>
      </div>
    </div>
    <LogoSection />
  </section>
</template>

<script>
import ApplyButton from '~/components/Common/ApplyButton/ApplyButton.vue';
import Glassdoor from '~/components/Common/Glassdoor/Glassdoor.vue';
import GradientCheckIcon from '~/components/Common/Svg/Gradient/GradientCheckIcon.vue';
import LogoSection from '~/components/RolePage/LogoSection/LogoSection.vue';

export default {
  components: {
    LogoSection,
    ApplyButton,
    Glassdoor,
    GradientCheckIcon,
  },
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  computed: {
    heroBadge() {
      return this.page?.title.replace('job', '');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './HeroSection.scss';
</style>
